import { useEffect, useState, useCallback } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

// Imperative, promise-based confirm/prompt so we never use native window.alert/confirm/prompt.
let _open = null;

export function confirmDialog(opts = {}) {
  return new Promise((resolve) => {
    if (!_open) { resolve(false); return; }
    _open({ kind: "confirm", confirmText: "Confirm", cancelText: "Cancel", ...opts, resolve });
  });
}

export function promptDialog(opts = {}) {
  return new Promise((resolve) => {
    if (!_open) { resolve(null); return; }
    _open({ kind: "prompt", confirmText: "OK", cancelText: "Cancel", inputType: "text", ...opts, resolve });
  });
}

export function DialogHost() {
  const [s, setS] = useState(null);
  const [val, setVal] = useState("");
  useEffect(() => {
    _open = (cfg) => { setS(cfg); setVal(cfg.defaultValue || ""); };
    return () => { _open = null; };
  }, []);

  const finish = useCallback((result) => { s?.resolve(result); setS(null); setVal(""); }, [s]);
  if (!s) return null;

  const onCancel = () => finish(s.kind === "prompt" ? null : false);
  const onConfirm = () => finish(s.kind === "prompt" ? val : true);

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="max-w-md" aria-describedby={undefined} data-testid="app-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">
            {s.title || (s.kind === "prompt" ? "Input required" : "Please confirm")}
          </DialogTitle>
        </DialogHeader>
        {s.message && <div className="text-sm text-slate-600 whitespace-pre-line">{s.message}</div>}
        {s.kind === "prompt" && (
          <input
            autoFocus
            type={s.inputType}
            value={val}
            placeholder={s.placeholder || ""}
            onChange={(e) => setVal(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") onConfirm(); }}
            className="erp-input mt-1"
            data-testid="prompt-input"
          />
        )}
        <DialogFooter className="mt-2 gap-2">
          <button className="erp-btn-secondary" onClick={onCancel} data-testid="dialog-cancel">
            {s.cancelText}
          </button>
          <button
            className={s.danger ? "erp-btn-danger" : "erp-btn-primary"}
            onClick={onConfirm}
            data-testid="dialog-confirm"
          >
            {s.confirmText}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
